interface ShouldShowPropertiesNearbyArgs {
  isExpandedSearch: boolean
  expandedPropertiesCount: number
}

export const shouldShowPropertiesNearby = ({
  isExpandedSearch,
  expandedPropertiesCount,
}: ShouldShowPropertiesNearbyArgs): boolean =>
  !isExpandedSearch && expandedPropertiesCount > 0
